import React from 'react';
import {
    TabDownloadProgress,
    type TabDownloadProgressArgType,
} from './TabDownloadProgress';

interface TabDownloadScreenProps extends TabDownloadProgressArgType {
    modalStep: number;
    isDownloadingTabs: boolean;
}

export const TabDownloadScreen = ({
    modalStep,
    isDownloadingTabs,
    tabs,
    layoutIds,
}: TabDownloadScreenProps) => {
    if (!(modalStep === 2 && isDownloadingTabs)) {
        return null;
    }

    return <TabDownloadProgress tabs={tabs} layoutIds={layoutIds} />;
};
